
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["attack"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "3ec51ecf7784799564d9.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			